import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle'
import Dialog from '@mui/material/Dialog'
const ClientSelection = ({open, close, ...rest}) => {
  const app = React.useContext(AppContext)
  const { totalProducts, selectedProducts, setSelectedProducts, deleteProducts, getProducts } = app.products

  
  const confirm = () => {
    deleteProducts()
    close()
  }
  const skus = (ps) => ps.reduce((pv, p) => pv ? `${pv}, ${p.sku}` : p.sku, false)
  const name = () => selectedProducts.length == 1? `Eliminar productos: ${getProducts(selectedProducts)[0].name}`: `Eliminar productos ${selectedProducts.length} productos con SKUs: (${skus(getProducts(selectedProducts))})`
  
  return (
    <Dialog onClose={() => setSelectedProducts(false)} open={open}>
    {selectedProducts && 
      <React.Fragment>
        <DialogTitle>{name()}</DialogTitle>
        <Button color='error' disabled={selectedProducts.length < 1 || selectedProducts.length >= totalProducts} onClick={confirm}>Eliminar</Button>
      </React.Fragment>
    }
    </Dialog>
  )
}
export default ClientSelection